import { SVGProps, Ref, forwardRef } from 'react';

export const CheckOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m5.99 10.52 7.02-7.02.99.99-8.01 8.01L2 8.51l.99-.99z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CheckOutlinedSize16Glyph.displayName = 'CheckOutlinedSize16Glyph';
